import { DURATION } from '../config.js';
import { showPreloader, hidePreloader } from '../preloader.js';
import { syncStaticSlides, setAnchorNav } from './static-slides.js';

export function initMenuNavigation(slides) {
  const menuLinks = document.querySelectorAll('.anchor-slides a');

  menuLinks.forEach(link => {
    link.addEventListener('click', e => {
      if (window.innerWidth <= 960) return;

      e.preventDefault();

      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#') || href === '#') return;

      if (!slides || slides.length === 0) {
        const pathParts = window.location.pathname.split('/');
        const langPrefix = pathParts[1]?.length === 2 ? `/${pathParts[1]}` : '';
        window.location.href = `${langPrefix}/${href}`;
        return;
      }

      navigateToSlide(slides, href.replace('#', ''));
    });
  });
}

export function handleHashNavigation(slides) {
  if (window.innerWidth <= 960) return;

  const hash = window.location.hash;
  if (!hash) return;

  navigateToSlide(slides, hash.replace('#', ''));

  history.replaceState(null, '', window.location.pathname);
}

function navigateToSlide(slides, targetId) {
  const targetSection = document.getElementById(targetId);
  if (!targetSection) return;

  const targetSlide = targetSection.closest('.swiper-slide');
  if (!targetSlide) return;

  const verticalSwiperEl = targetSlide.closest('.swiper.vertical');
  const verticalSwiper = slides.find(s => s.el === verticalSwiperEl);
  if (!verticalSwiper) return;

  const currentIndex = verticalSwiper.activeIndex;
  let targetIndex = Array.from(verticalSwiper.slides).indexOf(targetSlide);

  const horizontalSwiperEl = targetSlide.closest('.swiper.horizontal');
  let horizontalSwiper = null;
  let horizontalIndex = -1;

  if (horizontalSwiperEl) {
    horizontalSwiper = slides.find(s => s.el === horizontalSwiperEl);
    if (horizontalSwiper) {
      horizontalIndex = Array.from(horizontalSwiper.slides).indexOf(
        targetSlide
      );
      targetIndex = Array.from(verticalSwiper.slides).indexOf(
        horizontalSwiperEl.closest('.swiper-slide')
      );
    }
  }

  if (targetIndex === -1) return;

  showPreloader();
  setAnchorNav(true);

  setTimeout(() => {
    verticalSwiper.slideTo(targetIndex, DURATION);
    syncStaticSlides(verticalSwiper);

    if (horizontalSwiper && horizontalIndex !== -1) {
      horizontalSwiper.slideTo(horizontalIndex, DURATION);
      syncStaticSlides(horizontalSwiper);
    }

    if (!horizontalSwiper && targetSlide.querySelector('.swiper.horizontal')) {
      const targetHorizontalEl =
        targetSlide.querySelector('.swiper.horizontal');
      const targetHorizontal = slides.find(s => s.el === targetHorizontalEl);
      if (targetHorizontal) {
        targetHorizontal.slideTo(0, 0);
        syncStaticSlides(targetHorizontal);
      }
    }

    if (targetIndex > currentIndex) {
      Array.from(verticalSwiper.slides)
        .slice(currentIndex, targetIndex)
        .forEach(slideEl => {
          const horizontalEl = slideEl.querySelector('.swiper.horizontal');
          if (horizontalEl) {
            const horizontal = slides.find(s => s.el === horizontalEl);
            if (horizontal) {
              horizontal.slideTo(horizontal.slides.length - 1, 0);
              syncStaticSlides(horizontal);
            }
          }
        });
    }

    if (targetIndex < currentIndex) {
      Array.from(verticalSwiper.slides)
        .slice(targetIndex + 1, currentIndex + 1)
        .forEach(slideEl => {
          const horizontalEl = slideEl.querySelector('.swiper.horizontal');
          if (horizontalEl) {
            const horizontal = slides.find(s => s.el === horizontalEl);
            if (horizontal) {
              horizontal.slideTo(0, 0);
              syncStaticSlides(horizontal);
            }
          }
        });
    }
  }, 150);

  setTimeout(() => {
    hidePreloader();
    setAnchorNav(false);
  }, DURATION + 200);
}
